var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{class:{current: _vm.current, existing: !_vm.current},style:(("left: " + (_vm.position.left) + "px; top: " + (_vm.position.top) + "px")),attrs:{"color":_vm.current ? 'success' : 'red'}},[_vm._v("my_location")])}
var staticRenderFns = []

export { render, staticRenderFns }